import { createFileRoute } from '@tanstack/react-router';
import { openExperiments } from './-guard';

export const Route = createFileRoute('/_protected/restricted/')({
  beforeLoad: openExperiments,
});
